import get from 'lodash.get';
import React from 'react';
import { object, string, bool } from 'prop-types';
import { trackEvent } from 'dibs-tracking';
import intelligentFormat from 'dibs-currency-helpers/intelligentFormat';

import styles from './CartNav-style.scss';

const handleOnClick = (url) => {
    trackEvent({
        category: 'navigation',
        action: 'header navigation click',
        label: 'cart|pdp'
    });
    location.href = url;
};

const CartNavDropdownListContent = ({ isUserTypeTrade, items, currency: userCurrency }) => {
    const { edges } = items;

    return (
        <div>
            {edges.map(({ node = {} }) => {
                const item = node.item || node;
                const { title, isSold, photos, pricing, pdpURL, serviceId } = item;
                let prices = [];

                if (!isSold) {
                    const netPrices = get(pricing, 'netPrice.convertedAmountList');
                    const salePrices = get(pricing, 'salePrice.convertedAmountList');
                    prices = get(pricing, 'retailPrice.convertedAmountList');

                    if (salePrices) {
                        prices = salePrices;
                    } else if (isUserTypeTrade && netPrices) {
                        prices = netPrices;
                    }
                }

                let price;
                let photoPath;

                prices.some(({ currency, amount }) => {
                    price = amount;
                    return currency === userCurrency;
                });

                get(photos, '[0].versions', []).some(({ type, webPath }) => {
                    photoPath = webPath;
                    return type.name === 'small';
                });

                return (
                    <div key={serviceId}
                        className={styles.dropdownRow}
                        onClick={() => { handleOnClick(pdpURL); }}
                    >
                        <div className={styles.dropdownColumn}>
                            <div className={styles.dropdownItemImageWrapper}>
                                <img className={styles.dropdownItemImage} src={photoPath}/>
                            </div>
                        </div>
                        <div className={styles.dropdownColumn}>
                            <div className={styles.dropdownItemTitle}>{title}</div>
                            <div data-tn="cart-nav-dropdown-item-price" className={styles.dropdownItemPrice}>
                                { isSold ?
                                    <span className={styles.isSold}>Sold</span>
                                    : intelligentFormat(price, userCurrency)
                                }
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

CartNavDropdownListContent.propTypes = {
    currency: string,
    isUserTypeTrade: bool,
    items: object
};

export default CartNavDropdownListContent;



// WEBPACK FOOTER //
// ./src/components/CartNav/CartNavDropdownListContent.js